export default {
  columns: {
    title: 'Título',
    image: 'Imagen',
    button_url: 'URL del botón',
    button_text: 'Texto del botón',
    description: 'Descripción',
    visible: 'Visible',
    actions: 'Acciones',
  },
  buttons: {
    create_post: 'Crear publicación',
    edit: 'Editar',
    delete: 'Eliminar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
  },
  title: 'Publicaciones destacadas',
  delete_confirmation: '¿Seguro que quieres eliminar esta publicación?',
};
